export default "__VITE_ASSET__D4H1BqkU__"